export type State = {
    loading: boolean
}

export type Action = { type: "START_LOADING" } | { type: "END_LOADING" }

const initialState = {
    loading: false,
}

const LoadingReducer = (initialState: State, action: Action) => {
    switch (action.type) {
        case "START_LOADING":
            return {
                ...initialState,
                loading: true,
            }
        case "END_LOADING":
            return {
                ...initialState,
                loading: false,
            }
        default:
            throw new Error("Unhandled action type")
    }
}

export { LoadingReducer, initialState }
